define('middleware-set-training',['exports', '../../../helpers/component--set-structure.es'], function (exports, _componentSetStructure) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _componentSetStructure2 = _interopRequireDefault(_componentSetStructure);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    exports.default = function () {
        return function (next) {
            return function (action) {

                if (action.type == 'SET_TRAINING') {
                    var _action$training = action.training,
                        training = _action$training === undefined ? {} : _action$training;


                    action.components = (0, _componentSetStructure2.default)(training.componentsJSON);
                }

                next(action);
            };
        };
    };
});
